// extracted by mini-css-extract-plugin
export default {"container":"CustomSwitch_container__Gocfp","switch":"CustomSwitch_switch__2rPYT"};